import { UserPlusIcon as PhosphorUserPlusIcon } from "@phosphor-icons/react/dist/ssr/UserPlus";

import { createAppIcon } from "@/components/createAppIcon";

export const FollowIcon = /* @__PURE__ */ createAppIcon(PhosphorUserPlusIcon);
